import { render } from "./app-form-input-mask.vue?vue&type=template&id=8fb5092c"
import script from "./app-form-input-mask.vue?vue&type=script&lang=js"
export * from "./app-form-input-mask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__